// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IScheduledContributionRequestDto
 */
export interface IScheduledContributionRequestDto {
    /**
     * 
     * @type {number}
     * @memberof IScheduledContributionRequestDto
     */
    calendar_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IScheduledContributionRequestDto
     */
    tax_type?: IScheduledContributionRequestDtoTaxTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IScheduledContributionRequestDto
     */
    status?: IScheduledContributionRequestDtoStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof IScheduledContributionRequestDto
     */
    start_date?: Date;
}

/**
* @export
* @enum {string}
*/
export enum IScheduledContributionRequestDtoTaxTypeEnum {
    PRE_TAX = 'PRE_TAX',
    POST_TAX = 'POST_TAX'
}
/**
* @export
* @enum {string}
*/
export enum IScheduledContributionRequestDtoStatusEnum {
    ACTIVE = 'ACTIVE',
    SUSPENDED = 'SUSPENDED',
    DEACTIVATED = 'DEACTIVATED',
    REMOVED = 'REMOVED'
}


/**
 * Check if a given object implements the IScheduledContributionRequestDto interface.
 */
export function instanceOfIScheduledContributionRequestDto(value: object): value is IScheduledContributionRequestDto {
    return true;
}

export function IScheduledContributionRequestDtoFromJSON(json: any): IScheduledContributionRequestDto {
    return IScheduledContributionRequestDtoFromJSONTyped(json, false);
}

export function IScheduledContributionRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IScheduledContributionRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'calendar_id': json['calendar_id'] == null ? undefined : json['calendar_id'],
        'tax_type': json['tax_type'] == null ? undefined : json['tax_type'],
        'status': json['status'] == null ? undefined : json['status'],
        'start_date': json['start_date'] == null ? undefined : (new Date(json['start_date'])),
    };
}

export function IScheduledContributionRequestDtoToJSON(json: any): IScheduledContributionRequestDto {
    return IScheduledContributionRequestDtoToJSONTyped(json, false);
}

export function IScheduledContributionRequestDtoToJSONTyped(value?: IScheduledContributionRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'calendar_id': value['calendar_id'],
        'tax_type': value['tax_type'],
        'status': value['status'],
        'start_date': value['start_date'] == null ? undefined : ((value['start_date']).toISOString().substring(0,10)),
    };
}

